import type { HomeNavDrawer } from '#core/utils/nav-drawers'
import { buildHomeNavDrawers, filterByFeatureAccess } from '#core/utils/nav-drawers'

export function useHomeNavDrawers() {
  const auth = useAuth()

  return computed(() => {
    const ctx = { featureFlags: auth.featureFlags }

    const drawers = buildHomeNavDrawers()

    const withVisibleTiles = (drawer: HomeNavDrawer) => ({ ...drawer, tiles: filterByFeatureAccess(drawer.tiles, ctx) })

    return {
      'home-tools': withVisibleTiles(drawers['home-tools']),
      'home-research': withVisibleTiles(drawers['home-research']),
      'home-about': withVisibleTiles(drawers['home-about']),
    }
  })
}
